// This  function returns true if the ellipsis of a give html element is activated.
export const isEllipsisActive = (e: any) => e && e.offsetWidth < e.scrollWidth;
